import TownBuyerLandingPage from "./TownBuyerLandingPage";
const SicklervilleLanding = () => (
  <TownBuyerLandingPage townName="Sicklerville" slug="homes-for-sale-sicklerville" savedLinkId="10361" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-sicklerville" />
);
export default SicklervilleLanding;
